import { useCurrentDateStore } from '../stores/currentDateStore';

/**
 * 「今日」を取得する React Hook
 *
 * currentDateStore を購読し、日付変更時に自動的に再レンダリング
 *
 * ⚠️ 重要: React コンポーネント内で「今日」を取得する際は、
 * new Date() を直接使わず、必ずこのフックを使用すること。
 *
 * @returns 現在の「今日」（デバッグ上書き or 実際の今日）
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const today = useCurrentDate();
 *   return <div>今日: {today.toLocaleDateString()}</div>;
 * }
 * ```
 */
export function useCurrentDate(): Date {
  // overrideDate の変更を購読することで再レンダリングをトリガー
  // getCurrentDate はメモ化されないので overrideDate を購読する必要がある
  const overrideDate = useCurrentDateStore((state) => state.overrideDate);
  const getCurrentDate = useCurrentDateStore((state) => state.getCurrentDate);

  // overrideDate が null でない場合はその値を、null の場合は今日を返す
  if (overrideDate) {
    return overrideDate;
  }
  return getCurrentDate();
}

/**
 * 現在の日付を上書きする操作を取得するフック
 *
 * @returns setOverrideDate と resetToRealToday 関数
 */
export function useCurrentDateActions() {
  const setOverrideDate = useCurrentDateStore((state) => state.setOverrideDate);
  const resetToRealToday = useCurrentDateStore((state) => state.resetToRealToday);

  return { setOverrideDate, resetToRealToday };
}
